import { CustomerEmailConsumer } from '@cex-newsletter/aws-amplify/src/models';
import { AppFooter as AppFooterAdmin } from './footer-admin';
import { AppFooter as AppFooterJess } from './footer-jess';

export const AppFooter = {
    [CustomerEmailConsumer.JESS_DAVIS]: AppFooterJess
}[process.env.REACT_APP_CONSUMER] ?? AppFooterAdmin;
